import React, { memo } from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import RichText from '../RichText/RichText';
import Col from '../Utils/Col/Col';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';

interface RichTextContainerBlokProps {
  content: StoryblokRichtext;
  anchor_id: string;
}

interface RichTextContainerProps {
  blok: RichTextContainerBlokProps;
}

const ArticleContent: React.FC<RichTextContainerProps> = ({ blok }) => {
  return (
    <article
      className="pt-20"
      {...storyblokEditable(blok)}
      id={blok.anchor_id || ''}
    >
      <Container>
        <Grid>
          <Col span={{ md: 10, xl: 8 }} start={{ md: 2, xl: 3 }}>
            {blok.content && <RichText content={blok.content} />}
          </Col>
        </Grid>
      </Container>
    </article>
  );
};

export default memo(withBlokWrapper(ArticleContent));
